import React, { Component } from "react";
import { connect } from "react-redux";
import "./DynamicCovers.scss";
// import KwiatCoverImage from "../../../../assets/icons/Kwiat-Cover-Image.jpg";

const mapStateToProps = (state) => {
  return {
    cartItems: state.cartActions,
    basketInputObj: state.basketInputChange,
    tokenState: state.tokenState,
    loaderActions: state.loaderActions,
  };
};

class DynamicCover extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let { coverSelected } = this.props;
    return (
      <div className="kwiat_cover">
        <div className="kwiat_cover_logo">
          <img src={coverSelected.Logo} />
        </div>
        <div className="kwiat_cover_image">
          <img src={coverSelected.Image} />
        </div>
        <div className="kwiat_cover_desc">
          {/* #{this.props.basketInputObj.orderNbr} */}
          <br />
          {this.props.basketInputObj.desc}
        </div>
        {/* <div className="kwiat_cover_footer" id="kwiat_footer">
          KWIAT.COM / NEW YORK / LAS VEGAS
        </div> */}
      </div>
    );
  }
}

export default connect(mapStateToProps)(DynamicCover);
